<template>
  <div>
    <div v-if="loadingStatus">
      <v-skeleton-loader
        :loading="loadingStatus"
        class="mb-3 mt-4"
        type="card"
        elevation="2"
      >
      </v-skeleton-loader>
    </div>
    <div v-show="!loadingStatus">
      <!-- batting order -->
      <v-col md="6" sm="6" cols="12" class="mx-auto mt-3 d-flex mb-n6">
        <p v-if="$vuetify.breakpoint.mdAndUp" class="d-md-flex align-md-start">
          Batter Order to use:
        </p>
        <v-chip-group
          v-model="TeamStack.batter_order"
          active-class="light-green darken-3 white--text"
          class="mx-auto chip-selector"
          center-active
          multiple
        >
          <v-chip
            :disabled="disableBattingOrder"
            v-for="item in Batter"
            :key="item"
            :value="item"
          >
            {{ item }}
          </v-chip>
        </v-chip-group>
        <!-- {{ TeamStack.batter_order }} -->
      </v-col>
      <!-- batting order -->

      <v-row class="my-3 mx-2" justify="center">
        <v-col
          cols="12"
          md="3"
          sm="6"
          v-for="item in TeamStack.allTeams"
          :key="item.id"
        >
          <v-sheet elevation="4" shaped class="mt-7 my-2">
            <!-- opp team -->

            <v-row class="mx-2 mt-sm-n5">
              <!-- logo -->
              <v-col cols="3" md="3" sm="3">
                <v-avatar size="40" color="#ECEFF1">
                  <img :src="item.AwayTeamLogo" />
                </v-avatar>
                <p class="caption ml-2">{{ item.AwayTeam }}</p>
              </v-col>

              <!-- slider -->
              <v-col cols="8" md="8" sm="8">
                <v-slider
                  v-model="item.OpponentRange"
                  :max="Omax"
                  :min="Omin"
                  thumb-size="30"
                  thumb-label
                  class="align-center"
                >
                  <template v-slot:prepend>
                    <p class="caption" v-text="item.OpponentRange"></p>
                  </template>
                </v-slider>
              </v-col>

              <!-- checkbox -->
              <v-col cols="1" md="1" sm="1">
                <v-checkbox
                  class="mt-0 ml-n4"
                  v-model="item.AwayCheckbox"
                  :disabled="item.AwayDisableCheck"
                  @change="checkboxSelected"
                ></v-checkbox>
              </v-col>
            </v-row>

            <!-- home team -->
            <v-row class="mx-2">
              <!-- logo -->
              <v-col cols="3" md="3" sm="3">
                <v-avatar size="40" color="#ECEFF1">
                  <img :src="item.HomeTeamLogo" />
                </v-avatar>
                <p class="caption ml-2">{{ item.HomeTeam }}</p>
              </v-col>

              <!-- slider -->
              <v-col cols="8" md="8" sm="8">
                <v-slider
                  v-model="item.HomeRange"
                  :max="Hmax"
                  :min="Hmin"
                  thumb-size="30"
                  thumb-label
                  class="align-center"
                >
                  <template v-slot:prepend>
                    <p class="caption" v-text="item.HomeRange"></p>
                  </template>
                </v-slider>
              </v-col>

              <!-- checkbox -->
              <v-col cols="1" md="1" sm="1">
                <v-checkbox
                  class="mt-0 ml-n4"
                  v-model="item.HomeCheckbox"
                  :disabled="item.HomeDisableCheck"
                  @change="checkboxSelected"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>

      <!-- instruction -->
      <v-col cols="12" md="6" sm="12" class="mx-auto ma-2">
        <v-banner color="#0097A7" rounded class="Info-banner">
          <v-row>
            <v-col>
              <p class="body-1 font-weight-bold">
                Instructions
                <v-icon color="#FDD835">mdi-book-information-variant</v-icon
                >&nbsp;<br />
                <span
                  >Team stack allows you to pick players from the same team.
                  Examples:</span
                >
              </p>
            </v-col>
          </v-row>

          <ol class="text-body-2 white--text mt-n4">
            <li>
              ARI=3 optimizer will use 3 out of 4 highest projected players for
              each lineup.
            </li>
            <li>
              ARI = <span class="black--text">2</span>, + STL =
              <span class="black--text">2</span>, you will get 2 players from
              ARI & 2 players from STL.
            </li>
            <li>
              Primary stack - Move slider to determine how many players used
              from that team- you will get the highest projected players for
              that team.
            </li>
            <li>
              Secondary stack - Optimizer will give you random players from
              second team selected
            </li>
            <li class="font-weight-medium">
              By selecting box, you can select batting order for that team
            </li>
          </ol>
        </v-banner>
      </v-col>
      <!-- instruction -->

      <!-- button -->
      <v-row class="ma-5" justify="center" align="center">
        <v-col cols="3" md="2" sm="2" class="text-center">
          <v-btn class="ma-2 mx-auto" color="primary" @click="backButton">
            Back
          </v-btn>
        </v-col>

        <v-col cols="3" md="2" sm="2" class="text-center">
          <v-btn
            class="ma-2 mx-auto"
            color="success"
            @click="onClick(userID, TeamStack, slateId)"
          >
            Save
          </v-btn>
        </v-col>

        <v-col cols="3" md="2" sm="2" class="text-center">
          <v-btn
            class="ma-2 mx-auto white--text"
            color="#E53935"
            @click="resetPlayer"
          >
            Reset
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "MlbTeamStack",
  props: ["slateId"],

  data() {
    return {
      disableBattingOrder: true,
      Hmin: 0,
      Hmax: 4,
      Omin: 0,
      Omax: 4,
      userID: localStorage.getItem("user"),
      Batter: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    };
  },
  created() {
    this.fetchTeamStack();
  },
  computed: {
    ...mapGetters("MlbModule", ["loadingStatus", "getFilterByPosition"]),
    ...mapState("MlbModule", ["TeamStack"]),

    computedCheckboxSelected() {
      // check if all checkbox are unchecked...
      if (this.TeamStack.allTeams) {
        let allCheckboxResult = this.TeamStack.allTeams.every((team) => {
          return team.HomeCheckbox == false && team.AwayCheckbox == false;
        });
        if (!allCheckboxResult) {
          this.disableBattingOrder = false;
        } else this.disableBattingOrder = true;
        console.log("allCheckboxResult", allCheckboxResult);
      } else return;
    },
  },
  mounted() {
    this.computedCheckboxSelected;
  },

  methods: {
    fetchTeamStack() {
      let obj = {
        SlateID: this.slateId,
        user: this.userID,
      };
      this.$store.dispatch("MlbModule/getTeamStack", obj);
    },

    checkboxSelected() {
      // check if all checkbox are unchecked...
      let allCheckboxResult = this.TeamStack.allTeams.every((team) => {
        return team.HomeCheckbox == false && team.AwayCheckbox == false;
      });
      if (!allCheckboxResult) {
        this.disableBattingOrder = false;
      } else this.disableBattingOrder = true;
      console.log("allCheckboxResult", allCheckboxResult);

      // checking if any checkobx is checked...
      this.TeamStack.allTeams = this.TeamStack.allTeams.map((team) => {
        if (team.HomeCheckbox) {
          return {
            ...team,
            AwayDisableCheck: true,
            AwayCheckbox: false,
            HomeCheckbox: true,
            HomeDisableCheck: false,
          };
        } else if (team.AwayCheckbox) {
          return {
            ...team,
            AwayDisableCheck: false,
            AwayCheckbox: true,
            HomeCheckbox: false,
            HomeDisableCheck: true,
          };
        } else if (allCheckboxResult) {
          return {
            ...team,
            AwayDisableCheck: false,
            HomeDisableCheck: false,
          };
        } else {
          return {
            ...team,
            AwayDisableCheck: true,
            HomeDisableCheck: true,
            HomeCheckbox: false,
            AwayCheckbox: false,
          };
        }
      });
    },

    onClick(...args) {
      let allCheckboxResult = this.TeamStack.allTeams.every((team) => {
        return team.HomeCheckbox == false && team.AwayCheckbox == false;
      });

      if (
        !allCheckboxResult &&
        (!args[1].batter_order || args[1].batter_order.length === 0)
      ) {
        alert("Batting Order is Required.");
      } else {
        let filtered_data = [];
        args[1].allTeams.forEach(function (team) {
          filtered_data.push({
            AwayTeam: team.AwayTeamID,
            HomeTeam: team.HomeTeamID,
            HomeRangeMin: team.HomeRange,
            OpponentRangeMin: team.OpponentRange,
            HomeCheckbox: team.HomeCheckbox,
            AwayCheckbox: team.AwayCheckbox,
            AwayDisableCheck: team.AwayDisableCheck,
            HomeDisableCheck: team.HomeDisableCheck,
          });
        });
        this.$store
          .dispatch("MlbModule/getPlayerPerTeam", {
            slatId: args[2],
            id: args[0],
            batter_order: this.TeamStack.batter_order
              ? this.TeamStack.batter_order
              : [],
            allTeams: filtered_data,
          })
          .then(() => {
            this.$router.go(-1);
          });
      }
    },

    resetPlayer() {
      let obj = {
        slatId: this.slateId,
        userId: this.userID,
      };
      this.$store.dispatch("MlbModule/resetPlayers", obj).then(() => {
        let obj = {
          SlateID: this.slateId,
          user: this.userID,
        };
        this.$store.dispatch("MlbModule/getTeamStack", obj);
      });
    },

    backButton() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.chip-selector >>> .v-chip.v-size--default {
  border-radius: 8px;
}
</style>
